import useAuthenticatedQuery from './useAuthenticatedQuery';
export default useAuthenticatedQuery;
